export default "__VITE_ASSET__86IB2DBZ__"